import { render, staticRenderFns } from "./inviteReward.vue?vue&type=template&id=c6add4ee&scoped=true"
import script from "./inviteReward.vue?vue&type=script&lang=js"
export * from "./inviteReward.vue?vue&type=script&lang=js"
import style0 from "./inviteReward.vue?vue&type=style&index=0&id=c6add4ee&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6add4ee",
  null
  
)

export default component.exports